// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'iylik-denizi',
    appId: '1:610870440739:web:ab82f01026f0f27c659296',
    storageBucket: 'iylik-denizi.appspot.com',
    locationId: 'europe-west',
    apiKey: 'AIzaSyDJ78xwRjw5ICPZjjo77x6_OfPBlKw4NNM',
    authDomain: 'iylik-denizi.firebaseapp.com',
    messagingSenderId: '610870440739',
  },
  production: false
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
